import type {RankingThemeStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/RankingThemeStaticLandingPageVo.interface';
import type {
  StaticLandingRankingThemeParamInput,
  StaticLandingRankingThemeSectionParam,
} from '../generated/types';

export function createStaticLandingRankingThemeSectionParam(
  vo: RankingThemeStaticLandingPageVo,
  input: StaticLandingRankingThemeParamInput
): StaticLandingRankingThemeSectionParam {
  const isValidInputFilterType =
    input.filterType != null &&
    vo.filter_opt_list?.some(opt => opt.param === input.filterType);

  return {
    page: input.page,
    screenUid: input.screenUid,
    filterType: isValidInputFilterType
      ? input.filterType
      : vo.selected_filter_opt?.param,
    sortType: input.sortType ?? vo.selected_rank_opt?.param,
    txId: vo.tx_id ?? input.txId,
  };
}
